import { render, staticRenderFns } from "./ImportGonvernmentMandatory.vue?vue&type=template&id=082a375b&scoped=true"
import script from "./ImportGonvernmentMandatory.vue?vue&type=script&lang=js"
export * from "./ImportGonvernmentMandatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a375b",
  null
  
)

export default component.exports